import { DisplayLogin, DisplayLoginProps } from "./react.login";

import React, { ReactElement } from "react";
import { authenticateDebugName, useLogin, useUserData } from "./authentication.provider";
import { useThrowError } from "@me8eon/throw_error";
import { useDebug } from "@me8eon/debug";


function getUserRoleString(isAdmin: boolean, isDev: boolean): string {
    return `${isAdmin ? " - Admin" : ""}${isDev ? " - Dev" : ""}`;
}

export const SimpleDisplayLogin: DisplayLogin = (props: DisplayLoginProps) => {
    const { login, logout } = useLogin();
    const userData = useUserData();
    const { loggedIn, email } = userData;
    const debug = useDebug(authenticateDebugName);
    return <div>
        {loggedIn ? <div>
            <div data-testid="loggedin">Logged in as {email}{getUserRoleString(false, false)}</div>
            <button onClick={() => logout(debug)}>Logout</button>
        </div> : <button onClick={() => login(debug)}>Login</button>}
    </div>;
};

export function SimpleNotLoggedIn(): ReactElement {
    const { login } = useLogin();
    const { loggedIn } = useUserData();
    const throwError = useThrowError();
    const debug = useDebug(authenticateDebugName);
    if (loggedIn) return throwError("s/w", "Must not be logged in to use SimpleNotLoggedIn");
    return <div>Must be logged in
        <button onClick={() => login(debug)}>Login</button>
    </div>;
}
